import { useDataFormatter } from "@/composable/data-formatter";
import { DataPoint } from "@soft-db/d3-chart";
import { DataDefinition } from "@soft-db/data-formatter";

export const usePoints = () => {
	const { convertTo } = useDataFormatter();
	const convertY = (dataPoints: DataPoint[], dataDefinition: DataDefinition) => {
		const convertedData: DataPoint[] = [];
		for (const point of dataPoints) {
			if (point.y == null) {
				convertedData.push(point);
			} else {
				convertedData.push({
					...point,
					y: convertTo(point.y, dataDefinition),
				});
			}
		}

		return convertedData;
	};

	return { convertY };
};
